<script>
import {
    eventGroupState
} from '@app/store/eventGroupStore.svelte.js';
import {
    styleState
} from '@app/store/styleStore.svelte.js';
import {
    projectState
} from '@app/store/projectStore.svelte.js';
import {
    insertHistoryAction
} from '@app/store/historyStore.svelte.js';
import {
    modalState, hideModal
} from '@app/store/modalStore.svelte.js';
import {
    cliConfigState
} from '@app/store/cliConfigStore.svelte.js';
import {
    fade
} from 'svelte/transition';
import { onMount } from 'svelte';
import {
    tick
} from 'svelte';
import {
    BarLoader
} from 'svelte-loading-spinners'
import {
    saveAs
} from 'file-saver';
import * as m from "@app/paraglide/messages.js";

/* CC LIB */
import tcLib from '@cclib/lib/timecode.js';
import encode from "@cclib/functions/encode.js";
import defaults from "@cclib/lib/defaults.js";
import orderByTime from "@cclib/functions/eventGroups/orderByTime.js";
import removeHtmlEntities from "@cclib/functions/eventGroups/removeHtmlEntities.js";
import encodeHtml from "@cclib/functions/eventGroups/encodeHtml.js";
import offset from "@cclib/functions/events/tcOffset.js";
import formats from "@cclib/lib/formats.js";
import decode from "@cclib/functions/decode.js";
import removeInvalidEvents from "@cclib/functions/eventGroups/removeInvalidEvents.js";
import _EventGroup from '@cclib/classes/eventGroup.js';
import automaticOs from '@cclib/functions/special/automaticOffset.js';
import wrapStyledTextWithSpan from '@cclib/functions/quill/wrapStyledTextWithSpan.js'; 
let eventGroupDefaults = JSON.parse(localStorage.getItem("cc-event-group-defaults")) || {};

let language = eventGroupDefaults.language || "en-US",
    rtl = eventGroupDefaults.rtl,
    captionFormat = $state("mcc");

const profiles = [
    "copy",
    "wrap",
    "mp4faststart",
    "picon",
    "mov-YCbCr8Bit",
    "mov-dvcprohd",
    "mp4-h264",
    "mxf-xdcam-720p",
    "mxf-dvcprohd-720p",
    "mxf-xdcam-1080i",
    "mxf-dvcprohd-1080i",
    "mov-prores422",
    "mov-proreshq",
    "mxf-OP1a-MPEG",
    "mxf-OP1a-h264",
    "mxf-OP1a-HDF",
    "mxf-as-11-hd-dpp",
    "scaledown2000k",
    "scaledown500k",
    "mxf-as-11-sd-pal-dpp",
    "mxf-as-11-sd-ntsc-dpp",
    "hd1080-5000kbs",
    "hd720-2500kbs",
    "hd360-1250kbs",
    "h264-7500kbs",
    "Proxy-h264-5000kbs",
    "LBR-h264-10000kbs",
    "mxf-OP1a-JPEG2K",
    "mxf-AS-02-h264-10",
    "DASH-MP4-Multibitrate",
    "HLS-TS-Multibitrate",
    "TS-TR-01-JPEG-2000",
    "mxf-OP1a_HBR_50",
    "mp3-128kbps",
    "mp4-XAVC-S_4_2_0",
    "mp4-XAVC-S_4_2_2",
    "mov-prores444",
    "mov-proresxq",
    "aces",
    "dnxhd-mxf-720p",
    "dnxhd-mxf-1080p",
    "dnxhd-mxf-1080i",
    "dnxhr-mxf-10-hq",
    "dnxhr-mxf-sq",
    "dnxhr-mxf-lq",
    "TS-MPEG2",
    "TS-h264",
    "wave",
    "MXF-RDD-25",
    "amt3-LowQuality",
    "amt3-StandardQuality",
    "amt3-HiQuality",
    "amt3-HQX_10",
    "amt3-DNxHD36",
    "MP4-MultiOutput",
    "HEVC-h265-10000kbs",
    "mov-xdcam",
    "mkv-ffv1",
    "dnxhr-mxf-hq",
    "mov-proreslt",
    "mov-proresproxy",
    "mp4-vtt-h264",
    "kipro-prores-lt",
    "amt3-XDCam",
    "amt3-Proxy",
    "amt3-Uncompressed",
    "transport_stream",
    "mxf-xdcam35-1080i",
    "mxf-xdcam35-1080p",
    "mxf-xdcam35-720p",
    "mxf-avid-alpha",
    "mxf-jpegxs-main10",
    "mxf-jpegxs-light8",
    "ts-jpegxs-main10",
    "ts-jpegxs-light8",
    "mxf-avci-x00",
    "fmp4-h264",
    "ts-hevc",
    "ts-10bit",
    "mxf-op1a",
    "mxf-sonyhd",
    "mxf-as02",
    "mxf-avid",
    "mxf-amt",
    "mxf-amt-op1a",
    "mp4-fmp4",
    "mp4",
    "mov",
    "ts"
];

/* Electron */
const {
    shell
} = window;
const ipcRenderer = window.ipcRenderer; 
const fs = window.fs;
let path = window.path;
const spawn = window.spawn;

let ccEmbedPath = cliConfigState[0].options[1].selected;
let ccExtractPath = cliConfigState[0].options[2].selected;
let loggerEl;

onMount(async () => {
    loggerEl = document.getElementById('loggerOutput');
});

let mode = $state("embed"),
    running = $state(false),
    targetFolderPath = $state(""),
    logs = $state(""),
    profile = $state("wrap"),
    files = $state(),
    fileArray,
    ccFilePath,
    enableBitRate = $state(false),
    bitRate = $state(10000),
    tcOffset = $state("00:00:00:00"),
    eventGroup = $state(getSelectedEventGroup(["subtitle", "translation"]));

// Handler for file inputs
function handleFileInput(event) {
    files = Array.from(event.currentTarget.files || []);
}

async function writeToLog(message) {
    logs += message + "\n";
    await tick();
    loggerEl.scrollTop = loggerEl.scrollHeight;
    await tick();
}

async function runProcess() {
    try {
        running = true;
        if (mode === "embed") {
            ccFilePath = await exportSubtitles();
        } else {
            await writeToLog(m.drastic_tech_extract_start_log());
        }

        for (let i = 0; i < files.length; i++) {
            files[i].path = await window.webUtils.getPathForFile(files[i]);
        }

        fileArray = Array.from(files);

        if (mode === "embed") {
            embedNextFileOrEnd();
        } else {
            extractNextFileOrEnd();
        }

    } catch (err) {
        console.log(err);
        console.log(err.message);
        await writeToLog(err.message);
    }
}

async function embedNextFileOrEnd(){
    if (fileArray.length > 0){
        let nextSrcFile = fileArray.shift();

        await writeToLog(
            m.drastic_tech_embed_start_log({ name: nextSrcFile.name }),
        );
        embedCaptions(nextSrcFile, ccFilePath);
    } else {
        await writeToLog(m.drastic_tech_embed_complete_log());
        await writeToLog(m.drastic_tech_close_window_log());
        shell.showItemInFolder(ccFilePath);
        running = false;
    }

    return;
}

async function embedCaptions(srcFile, ccFile) {
    let targetFile = (process.platform !== "win32" ? path.sep : "") + path.join(...targetFolderPath.split(path.sep), srcFile.name);

    await writeToLog(
        m.drastic_tech_embed_command_log({
            command: `"${ccEmbedPath} -s ${srcFile.path} -t ${targetFile} -cc ${ccFile} -p ${profile} ${(enableBitRate ? "-kilobitrate" : "")} ${(enableBitRate ? bitRate : "")}`,
        }),
    );

    let embedProcess = spawn(`${ccEmbedPath}`, ["-s", `${srcFile.path}`, "-t", `${targetFile}`, "-cc", `${ccFile}`, "-p", `${profile}`, (enableBitRate ? "-kilobitrate" : ""), (enableBitRate ? bitRate : "")]);

    embedProcess.stdout.on('data', async (data) => {
        console.log(`stdout: ${data}`);
        await writeToLog(`${data}`);
    });

    embedProcess.stderr.on('data', async (data) => {
        console.error(`stderr: ${data}`);
        await writeToLog(m.drastic_tech_stderr_log({ message: `${data}` }));
    });

    embedProcess.on('close', async (code) => {
        console.log(`child process exited with code ${code}`);
        await writeToLog(m.drastic_tech_process_closed_log({ code }));
        embedNextFileOrEnd();
    });

    embedProcess.on('error', async function (err){
        console.error(err);
        console.error(`[DRASTIc error]: ${err.message}`);
        await writeToLog(m.drastic_tech_process_error_log({ error: err.message }));
    });

    return;
}

async function extractNextFileOrEnd(){
    if (fileArray.length > 0){
        let nextSrcFile = fileArray.shift();
        await writeToLog(
            m.drastic_tech_extract_start_file_log({ name: nextSrcFile.name }),
        );
        extractCaptions(nextSrcFile);
    } else {
        await writeToLog(m.drastic_tech_extract_complete_log());
        await writeToLog(m.drastic_tech_close_window_log());
        running = false;
    }

    return;
}

async function extractCaptions(srcFile) {
    let targetFile = (process.platform !== "win32" ? path.sep : "") + path.join(...targetFolderPath.split(path.sep), srcFile.name + "." + captionFormat);
    await writeToLog(
        m.drastic_tech_extract_command_log({
            command: `"${ccExtractPath} -s ${srcFile.path} -t ${targetFile} -c 0`,
        }),
    );

    let extractProcess = spawn(`${ccExtractPath}`, ["-i", `${srcFile.path}`, "-t", `${targetFile}`, "-c", `0`]);

    extractProcess.stdout.on('data', async (data) => {
        console.log(`stdout: ${data}`);
        await writeToLog(m.drastic_tech_stdout_log({ message: `${data}` }));
    });

    extractProcess.stderr.on('data', async (data) => {
        console.error(`stderr: ${data}`);
        await writeToLog(m.drastic_tech_stderr_log({ message: `${data}` }));
    });

    extractProcess.on('close', async (code) => {
        console.log(`child process exited with code ${code}`);
        await writeToLog(m.drastic_tech_extract_closed_log());

        await importSubtitleFile(targetFile, srcFile.name);
        extractNextFileOrEnd();
    });

    extractProcess.on('error', async function (err){
        console.error(`error: ${err.message}`);
        await writeToLog(m.drastic_tech_process_error_log({ error: err.message }));
    });

    return;
}

async function importSubtitleFile(ccFilePath, eventGroupName){
    try {
        await writeToLog(
            m.drastic_tech_importing_file_log({ format: captionFormat }),
        );
        let eventGroupOptions = {
                type: "subtitle",
                name: eventGroupName,
                language: language,
                rtl: rtl
            }

        eventGroupState.push({...(new _EventGroup(eventGroupOptions))});
        projectState.selected = eventGroupState.length - 1;

        /* Translate for Creator */
        let options = new defaults.options({
            profile: captionFormat === "scc" ? "scenerist" : "macCaption",
            formatOptions: formats.profileMapping[(captionFormat === "scc" ? "Scenarist V1.0" : "MacCaption 608/708")].options.decode,
            frameRate: projectState.frameRate,
            dropFrame: projectState.dropFrame,
            window : {
                width: styleState.width,
                height: styleState.height,
                xPadding: styleState.xPadding,
                yPadding: styleState.yPadding
            }
        });

        let fileContents = await fs.readFile(ccFilePath, 'utf8');
        let decodedEvGroup = await decode(fileContents, options);
        decodedEvGroup = encodeHtml(decodedEvGroup);
        decodedEvGroup = removeInvalidEvents(decodedEvGroup);
        decodedEvGroup = automaticOs(decodedEvGroup, projectState.frameRate, projectState.dropFrame);

        eventGroupState[projectState.selected].events = decodedEvGroup.events;

        insertHistoryAction({
            name: "import subtitles", //action name
            eventGroup: projectState.selected,
            snapshots: [{
                store: "eventGroupState",
                value: JSON.stringify(eventGroupState)
            }]
        });

        await writeToLog(
            m.drastic_tech_file_imported_log({
                format: captionFormat,
                name: eventGroupName,
            }),
        );
    } catch(err){
        console.log(err, err.message);
        await writeToLog(err.message);
    } finally {
        return;
    }
}

async function exportSubtitles() {
    await writeToLog(m.drastic_tech_exporting_file_log({ format: captionFormat }));
    let eventGroupIndex = eventGroupState.findIndex(group => {
        return group.id === eventGroup;
    });

    let captionFileName = eventGroupState[eventGroupIndex].name + "." + captionFormat;
    let copyOfEventGroup = JSON.parse(JSON.stringify(eventGroupState[eventGroupIndex]));

    copyOfEventGroup = orderByTime(copyOfEventGroup);
    copyOfEventGroup = removeHtmlEntities(copyOfEventGroup);

    /* tcOffset */
    if (tcOffset && tcOffset !== "00:00:00:00") {
        copyOfEventGroup.events.forEach((event, index, events) => {
            copyOfEventGroup.events[index] = offset(event, tcLib.tcToSec(tcOffset, projectState.frameRate, projectState.dropFrame), "add");
        });
    }

    /* Translate for Creator */
    let options = new defaults.options({
        profile: captionFormat === "scc" ? "scenerist" : "macCaption",
        formatOptions: formats.profileMapping[(captionFormat === "scc" ? "Scenarist V1.0" : "MacCaption 608/708")].options.encode,
        frameRate: projectState.frameRate,
        dropFrame: projectState.dropFrame,
        window: {
            width: styleState.width,
            height: styleState.height,
            xPadding: styleState.xPadding,
            yPadding: styleState.yPadding
        }
    });

    copyOfEventGroup.events.forEach((event, index, events) =>{
        events[index].text = wrapStyledTextWithSpan(event.text);
    });

    let output = await encode(copyOfEventGroup, options);
    let outputFilePath = (process.platform !== "win32" ? path.sep : "") + path.join(...targetFolderPath.split(path.sep), captionFileName);

    await fs.writeFile(outputFilePath, output);
    await writeToLog(
        m.drastic_tech_file_created_log({
            format: captionFormat,
            path: outputFilePath,
        }),
    );
    return outputFilePath;
}

function clearLogs() {
    logs = "";
}

function exportLogs() {
    let d = new Date();
    let fileBlob = new Blob([logs], {
        type: "text/plain;charset=utf-8"
    });

    saveAs(fileBlob, `drastic_logs_${d.getTime()}.txt`);
}

function selectTargetFolder() {
    ipcRenderer.invoke('selectFolder', {
        title: m.drastic_tech_select_folder_title(),
        properties: ["openDirectory", "createDirectory"]
    }).then((path) => {
        if (!path.canceled) {
            targetFolderPath = path.filePaths[0];
            sessionStorage.setItem("drasticDirPath", targetFolderPath);
        }
    });
}

function getSelectedEventGroup(validTypes) {
    let evGroup = eventGroupState[projectState.selected];
    if (evGroup) {
        if (validTypes.indexOf(evGroup.type) > -1) {
            return evGroup.id;
        } else {
            return false;
        }
    } else {
        return false;
    }
}

function validateTc(e) {
    tcOffset = tcLib.tcValidate(e.target.value, projectState.frameRate, projectState.dropFrame);
}

</script>

<div transition:fade={{duration: 100}} 
    class="modal {modalState.selected === 'drasticTech' ? 'show d-block' : ''}" 
    role="dialog" 
    aria-labelledby="drasticTechModalTitle"
    aria-describedby="drasticTechModalDesc"
    tabindex="-1" 
    id="DrasticTechModal">
    <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="drasticTechModalTitle">{m.drastic_tech_title()}</h4>
                <button type="button" class="btn-close" aria-label={m.drastic_tech_close_label()} onclick={hideModal}></button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-4">
                        <form id="drasticTechForm" aria-label={m.drastic_tech_export_options_aria()}>
                            <div class="mb-3 mb-4">
                                <label class="form-label" for="drasticMode">{m.drastic_tech_mode_label()}</label>
                                <select class="form-select" id="drasticMode" bind:value={mode} disabled={running} aria-disabled={running}>
                                    <option value="embed">{m.drastic_tech_mode_embed()}</option>
                                    <option value="extract">{m.drastic_tech_mode_extract()}</option>
                                </select>
                            </div>

                            <div id="targetFolderInputGroup" class="mb-3 p-3 border border-secondary rounded">
                                <button type="button" id="selectTargetBtn" class="btn btn-info text-white" onclick={selectTargetFolder} aria-label={m.drastic_tech_select_target_folder_aria()}>
                                    <i class="bi bi-folder" aria-hidden="true"></i> {m.drastic_tech_target_folder_button()}
                                </button>
                                <p class="form-text text-muted text-truncate mt-2 mb-0" aria-live="polite">
                                    {targetFolderPath || m.drastic_tech_no_folder_selected()}
                                </p>
                                {#if !targetFolderPath}
                                    <p class="form-text text-muted">{m.drastic_tech_target_folder_help()}</p>
                                {/if}
                            </div>

                            {#if mode === "embed"}
                            <div class="mb-3">
                                <label class="form-label" for="eventGroupSelect">{m.drastic_tech_event_group_label()}</label>
                                <select id="eventGroupSelect" disabled={running} class="form-select" bind:value={eventGroup} aria-disabled={running}>
                                    {#each eventGroupState.filter(group=>{return group.type === "subtitle" || group.type==="translation"}) as eventGroupOption}
                                    <option value={eventGroupOption.id}>{eventGroupOption.name}</option>
                                    {/each}
                                </select>
                            </div>
                            <div class="mb-3">
                                <label class="form-label" for="EventGroupSelection">{m.drastic_tech_intermediary_format_label()}</label>
                                <select disabled={running} class="form-select" bind:value={captionFormat}>
                                    <option>scc</option>
                                    <option>mcc</option>
                                </select>
                            </div>
                            <div class="mb-3">
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" bind:checked={enableBitRate} id="enableBitRateCheck">
                                    <label class="form-check-label" for="enableBitRateCheck">
                                                                            {m.drastic_tech_override_bitrate_label()}
                                    </label>
                                  </div>
                            </div>
                            <div class="mb-3">
                                <!-- Number input for bitrate in kilobytes -->
                                                                <label for="overrideTargetBitRate" class="form-label">{m.drastic_tech_target_bitrate_label()}</label>
                                <input type="number" step="0" min="1" class="form-control" id="overrideTargetBitRate" bind:value={bitRate} disabled={!enableBitRate}>
                            </div>
                            <div class="mb-3">
                                                                <label class="form-label" for="DrasticProfileSelection">{m.drastic_tech_profile_label()}</label>
                                <select disabled={running} class="form-select" bind:value={profile}>
                                    {#each profiles as profileOption}
                                        <option value={profileOption}>{profileOption}</option>
                                    {/each}                                    
                                </select>
                            </div>
                            <div class="mb-3">
                                <label class="form-label" for="sourceFilePicker">{m.drastic_tech_select_source_embed_label()}</label>
                                <input type="file" accept=".mxf, .gxf, .mov, .mpg, .mpeg, .mp4" multiple class="form-control" onchange={handleFileInput} />
                            </div>
                            {#if files}
                            <div class="mb-3">
                                <select disabled multiple class="form-control">
                                    {#each Array.from(files) as file}
                                        <option>{file.name}</option>
                                    {/each}
                                </select>
                            </div>
                            {/if}

                            <div class="mb-3">
                                <label class="form-label" for="tcOffset">{m.drastic_tech_tc_offset_label()}</label>
                                <input type="text" class="form-control" bind:value={tcOffset} onblur={validateTc} onfocus={(e)=>{e.target.select()}}/>
                            </div>
                            {:else}
                            <div class="mb-3">
                                <label class="form-label" for="sourceFilePicker">{m.drastic_tech_select_source_extract_label()}</label>
                                <input type="file" accept=".mxf, .gxf, .mov" multiple class="form-control" onchange={handleFileInput} />
                            </div>
                            {#if files}
                            <div class="mb-3">
                                <select multiple class="form-control">
                                    {#each Array.from(files) as file}
                                    <option>{file.name}</option>
                                    {/each}
                                </select>
                            </div>
                            {/if}
                            {/if}

                            <button type="button" class="btn btn-primary" disabled={!targetFolderPath || running || !files} onclick={runProcess}>{m.drastic_tech_start_process_button()}</button>
                        </form>
                    </div>
                    <div class="col">
                        <form id="loggerForm" aria-label={m.drastic_tech_debug_logging_aria()}>
                            <div class="mb-3">
                                <label class="form-label" for="loggerOutput">{m.drastic_tech_debug_logging_label()}</label>
                                <textarea 
                                    id="loggerOutput" 
                                    bind:value={logs} 
                                    placeholder={m.drastic_tech_debug_logging_placeholder()} 
                                    disabled 
                                    class="form-control" 
                                    rows="25"
                                    aria-live="polite"
                                    aria-readonly="true"></textarea>
                            </div>
                            <button type="button" id="exportLogsBtn" class="btn btn-primary" onclick={exportLogs} aria-label={m.drastic_tech_export_logs_aria()}>{m.drastic_tech_export_logs_button()}</button>
                            <button type="button" id="clearLogsBtn" class="btn btn-outline-dark" onclick={clearLogs} aria-label={m.drastic_tech_clear_logs_aria()}>{m.drastic_tech_clear_logs_button()}</button>
                        </form>
                        {#if running}
                        <div style="margin: 5% 0%" role="status" aria-label={m.drastic_tech_processing_aria()}>
                            <BarLoader size="250" color="#1eb4b2" unit="px" duration="3s"></BarLoader>
                            <p aria-live="polite">{m.drastic_tech_processing_label()}</p>
                        </div>
                        {/if}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<style lang="css">
textarea {
    font-family: plexMono;
}
</style>
